import type { FaireProductEntity } from "../../entity_types/product";

export const p_36eu2yanjt: FaireProductEntity = {
  token: "p_36eu2yanjt",
  type: "product",
  name: "Gourmetnut, Power Up 14, ANTIOXIDANT BODY BOOSTING (K), 6/13",
  brandToken: "b_22qxjttyk7",
  brandName: "NuEats",
  imageUrl:
    "https://cdn.faire.com/fastly/1a82b574027292d1327fa3e61e993b0fd6f422cb3fbd3281e87a637b3d1e4617.png",
  galleryImageUrls: [],
  priceDollars: 9.01,
  description:
    "More Than Your Average Trail Mix - Our carefully selected blend of pecans, cranberries, walnuts, raisins, blueberries, and dark chocolate create protein snacks with a taste that is out of this world. Wholesome, simple ingredients make this snack mix the perfect way to indulge without the guilt! We use 52% Cacao rich dark chocolate that melts in your mouth! Dark chocolate is a powerful source of antioxidants & is a much better alternative than milk chocolate, which is higher in sugar & calories.",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:39.611Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
